import { Component } from '@angular/core';

@Component({
    selector: 'black-invoice-payment-success',
    templateUrl: './invoice-payment-success.component.html',
    styleUrl: './invoice-payment-success.component.scss',
    standalone: false
})
export class InvoicePaymentSuccessComponent {

}
